//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, email } from 'vuelidate/lib/validators';
import emailjs from 'emailjs-com';
import  VueRecaptcha  from 'vue-recaptcha'
import alert from '../Alert';
export default {
    components: {
        alert,
        VueRecaptcha
    },
    props: {
        shown: Boolean
    },
    data () {
        return {
            settings: {
                userId:'user_8Pqp1JxKkQJs1O31LVbQc',
                serviceId:'service_8f8cii8',
                templates: {
                    msg:'template_bq1w27e',
                    eml:'template_h7h3e55'
                }
            },
            ui: {
                currentStep: 1,
                submissionButtonShown: true,
                working: false,
            },
            options: {
                categories:['Business Services','Design','General Enquiry','Software Development']
            },
            form: {
                name:'',
                company:'',
                emailAddress:'',
                contactNo:'',
                preferedContactMethod:'',
                message:'',
                preferBusinessHours: true,
                enquiryCategory:'',
                selectedTemplate:'',
                submissionStatus: undefined
            }
        }
    },
    methods: {
        init() {
            this.ui.currentStep = 1;
            // Animation to get users attention on closing mechanic
            document.querySelector('.fal.fa-times').style.WebkitTransitionDuration='.4s';
            document.querySelector('.fal.fa-times').style.webkitTransform = 'rotate(360deg)';
        },
        closeDialog() { 
            // this.mailDocumentLink = _blankModel;
            // this.$v.mailDocumentLink.$reset();
            this.$emit('onDismissed', 'emailCopy');
            if(this.ui.currentStep === 5) {
                document.querySelector('.trigger').classList.remove('drawn');
            }
        },
        submitMessage(template) {
            console.log('> Submit form: ', template);
            if(template === 'template_bq1w27e') {
                
                // Validate form
                this.$v.form.$touch();
                if  ((! this.$v.form.name.$invalid) &&
                    (! this.$v.form.emailAddress.$invalid) &&
                    (! this.$v.form.message.$invalid)) {

                        this.form.selectedTemplate = template;
                        this.ui.currentStep = 4;

                }
                else {
                    console.log('>Form validation failed ');
                }
            }
            else {
                this.$v.form.emailAddress.$touch();
                if (! this.$v.form.emailAddress.$invalid) {
                    this.form.selectedTemplate = template;
                    this.ui.currentStep = 4;
                }
                else {
                    console.log('>Form validation failed ', template);
                }
            }
        },
        
        onRecaptchaVerified() {
            console.log('> recapcha verified')
            this.ui.working = true;
            this.dispatch(this.form.selectedTemplate);
        },
        onRecaptchaExpired() {
            console.log('> recapcha expired')
            this.ui.submissionButtonShown = false;
            this.ui.recapchaShown = true;
        },
        dispatch(template) {
            console.log('> message dispatched')
            let that = this;
            emailjs.send(this.settings.serviceId, template, this.form, this.settings.userId)
                   .then((response) => {
                        that.form.submissionStatus = true;
                        this.onSuccess();
                    }, 
                    () => {
                        that.form.submissionStatus = false;
                    });
        },
        
        onSuccess() {
            this.ui.currentStep = 5;
            this.ui.working = false;
            console.log('Add class')
            this.$nextTick(() => {
                console.log('Start Animation')
                setTimeout(() => {  
                    document.querySelector('.trigger').classList.add('drawn');
                 }, 800)
                
            });
            
            
        },
        // Helpers for select
        resetModel() {

            // ui model
            this.ui.currentStep = 1;
            // form validation model

            // data model
            this.form.name = '';
            this.form.company = '';
            this.form.emailAddress = '';
            this.form.contactNo = '';
            this.form.preferedContactMethod = '';
            this.form.message = '';
            this.form.preferBusinessHours = true;
            this.form.enquiryCategory = '';
            this.form.selectedTemplate = ''
            // ui model
            this.ui.currentStep = 1;
            this.$v.$reset();
        },
        getLabel (scope) {
            console.log(scope)
            return scope.label
        },
        hasChild (scope) {
            return scope.opt.children.some(c => c.label === this.model)
        }
    },
    computed: {
        dialogTitle() {
            let response = 'Get in touch';

            if(this.ui.currentStep == 2) {
                response = 'Send me a message';
            }
            if(this.ui.currentStep == 3) {
                response = 'Email me';
            }
            if(this.ui.currentStep == 4) {
                response = 'Verify your humanity';
            }
            if(this.ui.currentStep == 5) {
                response = 'Thanks for reaching out!';
            }

            return response;
        }
    },
    validations: {
        form:{    
            name: {
                required: required
            },
            emailAddress: {
                required: required,
                email: email
            },
            message: {
                required: required
            },
            enquiryCategory: {
                required: required
            }
        }
    }
}
